

































































































import { Component, Prop, Emit } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'

import { showErrors, showNotification } from '@/utils/snack'
import { dateTimeToDisplay } from '@/utils/dateTime'
import { SnackType } from '@/interfaces/snack'
import { File } from '@/modules/File/interfaces/file'
import CaseFoldingCard from './CaseFoldingCard.vue'
import AppFileUploader from '@/components/AppFileUploader.vue'
import AppFilePreview from '@/components/AppFilePreview.vue'
import AppDialog from '@/components/AppDialog.vue'
import S3Handler from '@/mixins/s3'
import { deleteFile, renameFile } from '@/modules/File/gql/file.gql'
import { CaseReview } from '@/modules/Newcase/interfaces/case-review'

@Component({
  components: {
    CaseFoldingCard,
    AppFileUploader,
    AppDialog,
    AppFilePreview
  }
})
export default class CaseAttachmentsCard extends mixins(S3Handler) {
  @Prop({ type: Array as () => Array<File> }) readonly attachmentList!: File[]
  @Prop({ type: Number }) readonly masterId!: number
  @Prop({ type: String }) readonly masterType!: string
  @Prop({ type: Boolean }) readonly unFolding!: boolean
  @Prop({ type: String }) readonly title!: string
  @Prop({ type: Boolean, default: true }) readonly editable!: boolean
  @Prop({ type: Object as () => CaseReview }) readonly review!: CaseReview

  isSelectFile = false
  deleteFileDialog = false
  targetFile: File | null = null
  renaming = false
  nullFileName = false
  renameFileName = ''
  attachmentListLoading = false

  dateTimeToDisplay = dateTimeToDisplay

  attachmentTableColumn = [
    { field: 'name',
      title: 'File Name',
      slots: { default: 'name_default' },
      resizable: true
    },
    { field: 'createdAt',
      title: 'Created At',
      slots: { default: ({ row }: any, h: any) => {
        return [
          h('span', row.createdAt ? dateTimeToDisplay(row.createdAt) : '-')
        ]
      }
      }
    },
    { field: 'actions', title: 'Actions', slots: { default: 'action_default' }, width: 112, fixed: 'right' }
  ]

  get attachmentCardTitle () {
    return this.title || `Notes & Attachments (${this.attachmentList.length})`
  }

  get docType () {
    return this.masterType + '_ATTACHMENT'
  }

  addFile (e: Event) {
    e.preventDefault()
    e.stopPropagation()
    this.isSelectFile = true
  }

  uploadFileSuccess () {
    this.onSuccess()
  }

  deleteFile (file: File) {
    this.targetFile = file
    this.deleteFileDialog = true
  }

  async deleteFileConfirm () {
    if (!this.targetFile) {
      return
    }
    const { id } = this.targetFile
    try {
      const result = await this.$apollo.mutate({
        mutation: deleteFile,
        variables: {
          fileId: Number(id)
        }
      })
      this.deleteFileDialog = false
      const res = result.data.deleteFile
      if (res) {
        showNotification({
          msg: 'File deleted success!',
          type: SnackType.Success
        })
        this.onSuccess()
      }
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  renameFile (e: Event, item: File) {
    e.preventDefault()
    e.stopPropagation()
    this.targetFile = Object.assign({}, item)
    this.renameFileName = this.$R.dropLast(1, item.name.split('.')).join('')
    this.renaming = true
  }

  async renameConfirm (e: Event) {
    e.preventDefault()
    e.stopPropagation()
    this.nullFileName = !this.renameFileName
    if (this.nullFileName) {
      return
    }
    await this.renameFileNameConfirm()
    this.renaming = false
  }

  async renameCancel (e: Event) {
    e.preventDefault()
    e.stopPropagation()
    this.renaming = false
    this.renameFileName = ''
  }

  async renameFileNameConfirm () {
    if (!this.targetFile) {
      return
    }
    const { id, name } = this.targetFile
    const extention = this.$R.last(name.split('.'))
    try {
      await this.$apollo.mutate({
        mutation: renameFile,
        variables: {
          fileId: Number(id),
          fileName: this.renameFileName + '.' + extention
        }
      })
      showNotification({
        msg: 'Update the attachment name successfully',
        type: SnackType.Success
      })
      this.onSuccess()
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  async downloadFileHandler (file: any) {
    this.attachmentListLoading = true
    await this.downloadFile(file)
    this.attachmentListLoading = false
  }

  async previewFileHandler (file: any) {
    this.attachmentListLoading = true
    await this.previewFile(file)
    this.attachmentListLoading = false
  }

  @Emit('success')
  onSuccess () {
    // do nothing
  }
}
